import { render, staticRenderFns } from "./AnchorMenu.vue?vue&type=template&id=aa5dc00a&scoped=true"
import script from "./AnchorMenu.vue?vue&type=script&lang=ts"
export * from "./AnchorMenu.vue?vue&type=script&lang=ts"
import style0 from "./AnchorMenu.vue?vue&type=style&index=0&id=aa5dc00a&prod&lang=scss&scoped=true"
import style1 from "./AnchorMenu.vue?vue&type=style&index=1&id=aa5dc00a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5dc00a",
  null
  
)

export default component.exports